import { RequestMethodTypes } from "../helpers/constants";
import { fetchWrapper } from "../helpers";

/**
 * GET /v1/candidate/:candidateid/filenetdocuments/documentstatus
 * @param {string} oktaSubId oktaSub ID
 * @param {string} contractId Contract ID
 * @returns {Promise<Object[]>}
 * candidate-api/v1/candidate/{oktaSubId}/filenetdocuments/documentstatus?contractid={contractid}
 */
export const getCandidateDocumentStatuses = async (oktaSubId, contractId) => {
  let url = `${oktaSubId}/filenetdocuments/documentstatus`;
  if (contractId) {
    const params = new URLSearchParams({ contractid: contractId });
    url += `?${params.toString()}`;
  }
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url,
  });
  return response?.data;
};

/**
 * GET /v1/candidate/:candidateid/filenetdocuments/documentstatus
 * @param {string} oktaSubId oktaSub ID
 * @param {string} contractId Contract ID
 * @returns {Promise<Object[]>}
 * candidate-api/v1/candidate/{oktaSubId}/filenetdocuments/reqdocumentstatus?contractid={contractid}
 */
export const getCandidateReqDocumentStatuses = async (oktaSubId, contractId) => {
  let url = `${oktaSubId}/filenetdocuments/reqdocumentstatus`;
  if (contractId) {
    const params = new URLSearchParams({ contractid: contractId });
    url += `?${params.toString()}`;
  }
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url,
  });
  return response?.data;
};

/**
 * GET /v1/candidate/:oktasubid/filenetdocuments/bycontract
 * @param {string} oktaSubId Okta Sub ID
 * @param {string} contractId Contract ID
 * @param {string} [status] Optional status
 * @returns {Promise<Object[]>}
 */
export const getFilenetDocumentsByContractAndOkta = async (
  oktaSubId,
  contractId,
  status
) => {
  const params = new URLSearchParams({ contractid: contractId });
  if (status) params.append("status", status);
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url: `${oktaSubId}/filenetdocuments/bycontract?${params.toString()}`,
  });

  return response?.data;
};

/**
 * GET /v1/candidate/:oktasubid/filenetdocuments
 * @param {string} oktaSubId Okta Sub ID
 * @param {Object} params Optional query params: type, status, limit, offset
 * @returns {Promise<Object>}
 */
export const getFilenetDocuments = async (oktaSubId, params = {}) => {
  const query = Object.entries(params)
    .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
    .join("&");
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url: `${oktaSubId}/filenetdocuments${query ? "?" + query : ""}`,
  });
  return response?.data;
};

/**
 * POST /v1/candidate/:oktasubid/filenetdocuments
 * @param {string} oktaSubId Okta Sub ID
 * @param {Array<Object>} documents Array of FilenetDocument objects + contractid
 * @returns {Promise<Object>}
 */
export const insertFilenetDocuments = async (
  oktaSubId,
  documents,
  contractid,
  isRequested = false
) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.POST,
    url: `${oktaSubId}/filenetdocuments`,
    data: { documents, contractid, isRequested }, // Array<doc>
  });

  return response?.data;
};

/**
 * PUT /v1/candidate/:oktasubid/filenetdocuments/:id
 * @param {string} oktaSubId Okta Sub ID
 * @param {string|number} id Document ID
 * @param {Object} data Updated data
 * @returns {Promise<Object>}
 */
export const updateFilenetDocument = async (oktaSubId, id, data) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.PUT,
    url: `${oktaSubId}/filenetdocuments/${id}`,
    data,
  });
  return response?.data;
};

/**
 * DELETE /v1/candidate/:oktasubid/filenetdocuments/:id
 * @param {string} oktaSubId Okta Sub ID
 * @param {string|number} id Document ID
 * @returns {Promise<Object>}
 */
export const deleteFilenetDocument = async (oktaSubId, id) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.DELETE,
    url: `${oktaSubId}/filenetdocuments/${id}`,
  });
  return response?.data;
};

/**
 * GET /v1/candidate/:candidateid/filenetdocuments/guid/:guid
 * @param {string} candidateId Candidate ID
 * @param {string} guid Document GUID
 * @returns {Promise<Object>}
 */
export const getFileDocumentByGUID = async (candidateId, guid) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url: `${candidateId}/filenetdocuments/guid/${guid}`,
  });
  return response?.data;
};
